<template>
<div class="card-container">
    <card class="card-login card-white">
        <Header pageTitle="Registration Successful"></Header>
        <p v-if="$route.query.user== 'PartnerNation'">
            Your Partner Nation Manager has been notified of your access request.  An email confirmation link has been sent to the email address you provided; utilize the confirmation link to complete your registration.  Once your account has been reviewed and approved, you may proceed with logging into the system.
        </p>
        <p v-else>
            Your account Sponsor has been notified of your access request.  An email confirmation link has been sent to the email address you provided; utilize the confirmation link to complete your registration.  Once your account has been reviewed and approved, you may proceed with logging into the system.
        </p>
    </card>
</div>
</template>

<script>
import Header from "@/components/App/Header";
export default {
    name: "RegisterConfirmation",
    data() {
        return {};
    },
    components: {
        Header
    },
    methods: {
        onContinueClicked() {
            this.$router.push({
                name: "Login",
            });
        },
    },
};
</script>

<style scoped>
</style>
